import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
});

export type DorucenkaJobStatus = 'PENDING' | 'PROCESSING' | 'READY' | 'FAILED' | 'EXPIRED';

export interface DorucenkaDownloadJob {
  id: number;
  apartmentId: number;
  dateFrom: string;
  dateTo: string;
  status: DorucenkaJobStatus;
  documentCount: number | null;
  requestedAt: string;
  completedAt: string | null;
  expiresAt: string | null;
  errorMessage: string | null;
}

/** Request a new bulk-download job. Returns 409 if an active job already exists. */
export const requestDorucenkaDownload = async (
  apartmentId: number,
  dateFrom: string,
  dateTo: string,
): Promise<DorucenkaDownloadJob> => {
  const res = await axios.post<DorucenkaDownloadJob>(
    `${API_BASE}/apartments/${apartmentId}/dorucenka-downloads`,
    { dateFrom, dateTo },
    { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' }, withCredentials: true },
  );
  return res.data;
};

/** Poll for the most recent download job for the apartment. Returns null if none exists yet. */
export const getCurrentDorucenkaDownloadJob = async (
  apartmentId: number,
): Promise<DorucenkaDownloadJob | null> => {
  const res = await axios.get<DorucenkaDownloadJob>(
    `${API_BASE}/apartments/${apartmentId}/dorucenka-downloads/current`,
    { headers: getAuthHeaders(), withCredentials: true, validateStatus: s => s === 200 || s === 204 },
  );
  return res.status === 204 ? null : res.data;
};

/** Fetch a short-lived presigned S3 URL for downloading the READY ZIP, then open it. */
export const downloadDorucenkaZip = async (
  apartmentId: number,
  jobId: number,
): Promise<void> => {
  const res = await axios.get<{ url: string }>(
    `${API_BASE}/apartments/${apartmentId}/dorucenka-downloads/${jobId}/download`,
    { headers: getAuthHeaders(), withCredentials: true },
  );
  window.open(res.data.url, '_blank');
};
